import React, { useState, useContext } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Select,
  MenuItem,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ModalContext } from '..';
import AlertEnum from '../../Alert/enums/AlertEnum';
import { useSelector } from 'react-redux';
import { addImagesToReport, setActiveDraftReport } from '../../../../store/slices/reportSlice';
import { useAppDispatch } from '../../../../store/configureStore';
import { storeReportInfo } from '../../../../store/slices/reportSlice';
import { useHistory } from 'react-router-dom';

/**
 * This is the second step of the report modal
 * It allows selected images to be added to an existing report
 *
 * @param {*} open - the current state of the modal, whether it is open or not
 * @param {*} setOpen - function to set the state of the modal
 * @returns {JSX.Element} - The AddToReport component
 */

export default function AddToReport({ open, setOpen, selectedImageIds }) {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { closeModal, handleAlert } = useContext(ModalContext);
  const { draftReports, reportInfo } = useSelector((state) => state.reportData);
  const [disabled, setDisabled] = useState(false);

  const [item, setItem] = useState(reportInfo?.options?.id);

  const handleChangeDraftReport = ({ target }) => {
    setItem(target.value);
    dispatch(setActiveDraftReport(target.value));
  };

  const addImages = async () => {
    setDisabled(true);
    const newReportInfo = await dispatch(addImagesToReport(reportInfo, selectedImageIds));
    dispatch(storeReportInfo(newReportInfo));

    handleAlert(AlertEnum.REPORT_UPDATED);
    closeModal();

    history.push(`/report/${reportInfo.options.id}`);
  };

  return (
    <Accordion
      expanded={open === 'AddToReport'}
      onChange={() => setOpen('AddToReport')}
      sx={container}
      square
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={text}>Add To An Existing Draft Report</Typography>
      </AccordionSummary>
      <AccordionDetails sx={details}>
        <div>
          <Select sx={select} value={item} onChange={handleChangeDraftReport}>
            {draftReports.map((report) => (
              <MenuItem key={report.report_id} value={report.report_id}>
                {report.report_name}
              </MenuItem>
            ))}
          </Select>
          <Button
            variant="contained"
            color="secondary"
            sx={button}
            onClick={addImages}
            disabled={disabled}
          >
            Add To Report
          </Button>
        </div>
      </AccordionDetails>
    </Accordion>
  );
}

const select = {
  width: '470px',
};

const container = {
  '::before': {
    display: 'none',
  },
  boxShadow: 'none',
};

const text = {
  fontSize: '18px',
  display: 'flex',
  alignItems: 'center',
};
const details = { display: 'flex', justifyContent: 'center' };

const button = { float: 'right', marginTop: 2 };
